import {
  NgModule,
  ModuleWithProviders,
  SkipSelf,
  Optional,
  NgModuleRef,
  InjectionToken,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ApiConfigManager, ApiConfigOptions, ModuleSourceInfo } from '@sg/api/base-api-lib';
import { UsersApiClient } from './services';
import { UsersApiConfig } from './api-config';

declare module '../../../base-api-lib/src/lib/api-config-manager' {
  interface ApiConfigOptionsStore {
    usersApiConfig?: ApiConfigOptions;
  }
  interface ApiConfigManager {
    usersApiConfig: UsersApiConfig;
  }
}

export const CONFIG_FACTORY_TOKEN = new InjectionToken('UsersApiModule Config Factory');

@NgModule({
  imports: [],
  declarations: [],
  exports: [],
  providers: [UsersApiClient],
})
export class UsersApiModule {
  public static forRoot(
    configFactory?: (cfgMgr?: ApiConfigManager) => UsersApiConfig,
  ): ModuleWithProviders<UsersApiModule> {
    return {
      ngModule: UsersApiModule,
      providers: [{ provide: CONFIG_FACTORY_TOKEN, useValue: configFactory }],
    };
  }

  constructor(
    cfgMgr: ApiConfigManager,
    moduleRef: NgModuleRef<any>,
    @Optional() @SkipSelf() parentModule: UsersApiModule,
    @Optional() http: HttpClient,
  ) {
    if (parentModule) {
      throw new Error('UsersApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575',
      );
    }

    const configFactory: (cfgMgr?: ApiConfigManager) => UsersApiConfig =
      moduleRef.injector.get<any>(CONFIG_FACTORY_TOKEN);
    const config = configFactory
      ? configFactory(cfgMgr)
      : new UsersApiConfig(cfgMgr.withBase(cfgMgr.getRawConfig('usersApiConfig')));
    cfgMgr.addApiConfig('usersApiConfig', config);
  }
}
